<mat-card  fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
    <mat-icon *ngIf="data.type === 'Success'" svgIcon="app_tick"></mat-icon>
    <mat-icon *ngIf="data.type === 'Error'" class="text-primary bg-primary-contrast rounded">cancel</mat-icon> 
    <mat-icon *ngIf="data.type === 'Warning'" svgIcon="app_warning"></mat-icon>
    <mat-icon *ngIf="data.type === 'Info'" svgIcon="app_warning" class="rotate"></mat-icon>
    <div class="text-accent-lighter">{{ data.message }}</div>
</mat-card>